import React, { useState, useEffect } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import AxiosWrapper from '../../../../services/axios';
import marketing from '../../../../services/marketing';
import PixelsService from '../../../../services/pixels';
import AdobeScript from '../../../../services/adobeScript';
import { InactiveDetection } from '../../../../services/inactiveDetection';
import Layout from '../registration/layout';

function ApprovedGrandBank() {

    const brandSettings = useStoreState(state => state.siteSettingsModel.brandSettings);
    const setting = useStoreState(state => state.siteSettingsModel);
    const applicationResult = useStoreState(state => state.applicationResultModel.applicationResult);
    const cardColors = useStoreState(state => state.siteSettingsModel.CardColors);
    const productSettings = useStoreState(state => state.siteSettingsModel.productSettings);
    const applicantData = useStoreState(state => state.applicantModel.applicant);
    const alResult = useStoreState(state => state.alResult);
    const setAlResult = useStoreActions(actions => actions.setAlResult);
    const [CardImg, setCardImg] = useState(brandSettings.CardImage);
    const utms = new marketing()
    const client = new AxiosWrapper();
    const Flow = useStoreState(state => state.siteSettingsModel.mainSettings.Flow);
    const getRoutingSettings = useStoreActions(state => state.routingSettingsModel.getRoutingSettings);
    const websiteSettings = useStoreState(state => state.siteSettingsModel.websiteSettings);
    const PixelService = new PixelsService();
    const WaterfallEvents = { "DM": 10, "PREQUAL": 6, "CFC": 18, "STANDALONE": 24, "CS": 29 };
    const adobe = new AdobeScript();
    const isECSWelcomeScreenActive = Object.values(websiteSettings).find(ws => ws.Name === "ECSWelcomeScreenActive")?.Value || false;
    //Result event sended to GA

    InactiveDetection.setInactiveTitle("Explore your new benefits");

    useEffect(() => {
        const disableBackButton = (event) => {
            event.preventDefault();
            window.history.forward();
        };

        window.addEventListener('popstate', disableBackButton);

        return () => {
            //window.removeEventListener('popstate', disableBackButton);
        };
    }, []);

    useEffect(() => {
        if (cardColors.length > 0) {
            // eslint-disable-next-line array-callback-return
            cardColors.map((card) => {
                if (card.Code === applicantData.cardColorCode) {
                    setCardImg(card.ColorCardFileName)
                    return 0;
                }
            })
        }

        if (alResult === false) {
            PixelService.pageView("/approved").approvedCalls(applicationResult.ref_number)
            utms.trackEvent(WaterfallEvents[Flow] || 0, Flow, applicationResult.ref_number, productSettings.ProductId, "Flow");
            adobe.event('approved')
            setAlResult(true)
        }
        getRoutingSettings({ Url: setting.domain, Route: "/approved" });
    }, [])

    useEffect(() => {
        if (applicationResult.product_code || typeof applicationResult.product_code !== 'undefined' || applicationResult.product_code !== "") {
            localStorage.setItem("TCProductCode", applicationResult.product_code)
        }

    }, [applicationResult.product_code])

    return (
        <div className="resultpage">
            <hr style={{ backgroundColor: brandSettings.Primary, height: '10px' }} />
            <div className="ribbonGB" style={{ backgroundColor: 'white'}}>
                <h1 className='mx-auto p-3 fw-bold'>
                    <span style={{ color: brandSettings.Primary }}>
                        Congratulations!<br />You’ve Been Approved!
                    </span>
                </h1>
            </div>
            <div className="container">

                <div className='pt-3' style={{ backgroundColor: 'rgb(247, 247, 247)' }}>
                    {/* {
                    applicationResult.ref_number !== "" ? */}
                    <div className="row mb-3 mt-4" >
                        <div className="col-lg-12 text-center fw-bold">
                            <p style={{ fontSize: "1.7rem" }}><strong>Reference #: {applicationResult.ref_number}</strong></p>
                        </div>
                    </div>
                    <></>
                    {/* } */}

                    <hr></hr>

                    <div className='row mb-4'>
                        <div className='card' style={{ border: 'none', backgroundColor: 'transparent' }}>
                            <div className='card-body no-bottom-margin  row' style={{ "marginBottom": "0 !important" }}>
                                <div className="col-lg-4 text-center mb-3 mb-md-0">
                                    <img
                                        style={{ width: "auto", maxHeight: "420px" }}
                                        className="col-lg-12" src={CardImg} alt={brandSettings.ProductName}
                                    />
                                </div>
                                <div className="col-lg-8 pt-0 result-message declined text-center text-md-left px-3 px-md-0">
                                    <p style={{ fontSize: "2rem" }}>
                                        <>Thank you for choosing the Grand.bank<sup>&reg;</sup> Plus Mastercard<sup>&reg;</sup>, issued by {brandSettings.BankName} FSB<sup>&reg;</sup> and serviced by Continental Finance Company.</>
                                    </p>
                                    <p style={{ fontSize: "2rem" }}>
                                        <strong>Your new Grand.bank<sup>&reg;</sup> Plus Credit Card should arrive in 7 to 10 days. </strong>
                                    </p>
                                    <p style={{ fontSize: "2rem" }}>
                                        <strong>Initial Credit Limit:</strong> <br />
                                        <strong><span style={{ fontSize: "2em" }}>${applicationResult.credit_limit}</span></strong>
                                        <small>(subject to available credit)</small>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {isECSWelcomeScreenActive &&  <Layout applicantId={applicationResult.ref_number} /> }     

            </div>
        </div>
    );

}

export default ApprovedGrandBank;